import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFoundPage.css';

export default function NotFoundPage() {
    const navigate = useNavigate();

    const goHome = () => navigate('/');
    const goProfile = () => navigate('/profile');

    return (
        <div className="notfound-page">
            <div className="notfound-card">
                <div className="notfound-pill">404</div>

                <h1 className="notfound-title">
                    Такой страницы пока нет
                </h1>

                <p className="notfound-text">
                    Похоже, вы открыли адрес, которого нет в нашем сайте.
                    Возможно, ссылка устарела или в адресе закралась опечатка.
                </p>

                <p className="notfound-hint">
                    Попробуйте вернуться на главную или в профиль —
                    оттуда всегда можно запустить нужную презентацию.
                </p>

                <div className="notfound-actions">
                    <button className="notfound-btn primary" onClick={goHome}>
                        На главную
                    </button>
                    <button className="notfound-btn outline" onClick={goProfile}>
                        В профиль
                    </button>
                </div>
            </div>
        </div>
    );
}
